type PictureSize = 'small' | 'medium' | 'large';

export interface Product {
  tags?: string[];
  purchase_url?: string;
  sku: string;
  type?: string;
  description_text: string;
  name: string;
  pictures: Record<PictureSize, string>[];
  is_used?: number;
  category: { id: string; name: string }[];
  brand: { id: number; name: string };
  retailer?: { id: number; name: string };
  color?: string;
  swatch_url?: string;
  size?: string[];
  material?: string;
  simple_color_name?: string;
  created_on?: number;
  modified_on?: number;
  country?: string[];
  product_type?: string[];
  user_visible?: boolean;
  supplier?: string;
  tag?: string;
  currency: string;
  generic_name: string;
  id: string;
  estimated_ship_date?: any;
  language?: string;
  specifications: Record<string, any>;
  allowed_to_order?: boolean;
  mock?: {
    approval_status?: string;
    price?: {
      current?: number;
      msrp?: number;
      low_stock?: boolean;
    };
  };
}

export type ProductCardType = 'narrow' | 'wide';

export const Status = {
  APPROVAL_REQ: 'APPROVAL REQ',
  EXCP_APPROVAL_REQ: 'EXCP APPROVAL REQ',
  EXCEPTION_REQUIRED: 'EXCEPTION_REQUIRED',
  RECOMMENDED: 'RECOMMENDED',
} as const;

export interface Color {
  color: string;
  background: string;
}
